import { createSelector } from '@ngrx/store';
import * as fromCards from '../reducers';
import * as fromCardsReducer from '../reducers/add-credit-card.reducer';

export const selectAddCreditCardResponse = createSelector(fromCards.selectAddCreditCardState, fromCardsReducer.addCreditCardResponse);

export const selectAddCreditCardLoaded = createSelector(fromCards.selectAddCreditCardState, state => state.loaded);

export const selectAddCreditCardFailure = createSelector(fromCards.selectAddCreditCardState, fromCardsReducer.loadCreditCardFailure);

export const selectAddDebitCardResponse = createSelector(fromCards.selectAddCreditCardState, fromCardsReducer.addDebitCardResponse);
